import _ from 'lodash'
import { useMemo } from 'react'
import { useParams } from 'react-router-dom'

import { useGetExpertiseQuery } from '@/core/services/expertise'

import SelectTranscriptionDialog, { SelectTranscriptionDialogProps } from '../components/SelectTranscriptionDialog'

export default function SelectTranscriptionDialogContainer(props: Pick<SelectTranscriptionDialogProps, 'onSelect'> & {expertiseId?: string}) {
  const { onSelect } = props
  const { expertiseId: paramExpertiseId } = useParams()
  const expertiseId = props.expertiseId || paramExpertiseId

  const { data: expertise } = useGetExpertiseQuery(expertiseId ?? '', { skip: !expertiseId })

  const sentences = useMemo(() => _.compact(_.map(expertise?.dictaphones, (dictaphone) => dictaphone.text)), [expertise])

  return <SelectTranscriptionDialog onSelect={onSelect} sentences={sentences} />
}
